import React, { Component } from 'react'
import './styles/ServicesEdit.css'
import firebase from '../../firebase'

import Notifications, { notify } from 'react-notify-toast';

export default class ServicesEdit extends Component {

	constructor(props) {
		super(props);

		this.state = {
			line1: "",
			line2: "",
			line3: "",
			line4: "",
			disabledForm: true,
		}

		this.show = notify.createShowQueue();
	}

	componentDidMount() {
		const servicesRef = firebase.database().ref('services');

		this.show('Data is loading. Please wait.', "warning", 2000);

		servicesRef.once('value').then((snapshot) => {
			let items = snapshot.val();

			this.setState({
				line1: items.line1,
				line2: items.line2,
				line3: items.line3,
				line4: items.line4,
				disabledForm: false
			});

			this.show('Data is loaded.', "success", 2000);

		}).catch(() => {
			this.show('Data failed to load.', "error", 2000);
		});
	}

	handleChangeLine1 = (event) => {
		this.setState({
			line1: event.target.value
		});
	}

	handleChangeLine2 = (event) => {
		this.setState({
			line2: event.target.value
		});
	}

	handleChangeLine3 = (event) => {
		this.setState({
			line3: event.target.value
		});
	}

	handleChangeLine4 = (event) => {
		this.setState({
			line4: event.target.value
		});
	}

	updateServices = () => {

		if (!this.state.disabledForm) {

			this.setState({
				disabledForm: true
			})

			const servicesRef = firebase.database().ref('services');

			this.show('Data is updating...', "warning", 2000);

			servicesRef.set({
				line1: this.state.line1,
				line2: this.state.line2,
				line3: this.state.line3,
				line4: this.state.line4,
			}, (error) => {

				this.setState({
					disabledForm: false
				});

				if (error) {
					this.show('Data failed to update.', "error", 5000);
				} else {
					this.show('Data Saved. Awesome!', "success", 5000);
				}
			})

		}
	}

	clearText = () => {
		this.setState({
			line1: "",
			line2: "",
			line3: "",
			line4: "",
		})
	}

  render() {
    return (
      <div className = "services-form-wrapper">
		<Notifications />
        <div className = "box box-med">
					<div className="services-form-container">
						<div className="line-input">
							Line 1:
							<input className="txt-input" value={this.state.line1} onChange={this.handleChangeLine1} disabled={this.state.disabledForm} />
						</div>

						<div className="line-input">
							Line 2:
							<input className="txt-input" value={this.state.line2} onChange={this.handleChangeLine2} disabled={this.state.disabledForm} />
						</div>

						<div className="line-input">
							Line 3:
							<input className="txt-input" value={this.state.line3} onChange={this.handleChangeLine3} disabled={this.state.disabledForm} />
						</div>

						<div className="line-input">
							Line 4:
							<input className="txt-input" value={this.state.line4} onChange={this.handleChangeLine4} disabled={this.state.disabledForm} />
						</div>

						<div className="btn-container">
							<button className="btn btn-submit" onClick={this.updateServices}>Submit</button>
							<button className="btn btn-plain" onClick={this.clearText}>Clear</button>
						</div>
					</div>
				</div>
      </div>
    )
  }
}
